export const fadeInAudio = (
  audio: HTMLAudioElement,
  duration: number,
  volume: number = 1
) => {
  const fadeInInterval = setInterval(() => {
    if (audio.volume < volume) {
      audio.volume = Math.min(audio.volume + 0.01, volume);
    } else {
      clearInterval(fadeInInterval);
    }
  }, duration / 100);
};

export const fadeOutAudio = (audio: HTMLAudioElement, duration: number) => {
  if (audio.paused) {
    audio.currentTime = 0;
    return;
  }
  const fadeOutInterval = setInterval(() => {
    if (audio.volume > 0) {
      audio.volume = Math.max(audio.volume - 0.01, 0);
    } else {
      clearInterval(fadeOutInterval);
      audio.pause();
      audio.currentTime = 0;
    }
  }, duration / 100);
};

export const resetAudio = (audio: HTMLAudioElement | undefined) => {
  if (!audio) {
    return;
  }

  if (!audio.paused) {
    audio.pause();
  }

  audio.currentTime = 0;

  audio.load();
};
